import { render } from "./UpdateUnitDetailsForm.vue?vue&type=template&id=6d06d258&scoped=true"
import script from "./UpdateUnitDetailsForm.vue?vue&type=script&lang=js"
export * from "./UpdateUnitDetailsForm.vue?vue&type=script&lang=js"

import "./UpdateUnitDetailsForm.vue?vue&type=style&index=0&id=6d06d258&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\ms\\ms-by-bimms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d06d258"]])

export default __exports__